import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PermissionType } from 'app/enums/permission.enum';
import { AuthService } from 'app/services/auth.service';

@Component({
    selector: 'app-alert-actions',
    templateUrl: './alert-actions.component.html',
    styleUrls: ['./alert-actions.component.scss']
})
export class AlertActionsComponent implements OnInit {
    @Input() id: number;
    @Input() sourceId;
    @Input() alertStatus;
    @Input() canCompleted: boolean;
    @Input() canBeEdited: boolean;
    @Output() action: EventEmitter<any> = new EventEmitter();
    deleteButton:boolean;
    constructor(authService: AuthService) { 
        this.deleteButton = authService.userHasPermission(PermissionType.AlertDelete);
    }

    ngOnInit(): void {
    }

    actionClick(action: string): void {
        if(action == 'view'){
            this.action.emit({id: this.id, action, canCompleted: this.canCompleted});
        }else{
            this.action.emit({id: this.id, action});
        }
    }
}
